import type React from "react";

interface PhotoUploadProps {
  photoUrl?: string;
  onUpload: (e: React.ChangeEvent<HTMLInputElement>) => void | Promise<void>;
  uploading: boolean;
  size?: "md" | "lg";
  uploadLabel?: string;
  placeholder?: React.ReactNode;
  alt?: string;
}

const PhotoUpload: React.FC<PhotoUploadProps> = ({
  photoUrl,
  onUpload,
  uploading,
  size = "md",
  uploadLabel = "Change Photo",
  placeholder = "\u{1F464}",
  alt = "Profile",
}) => {
  const dimension = size === "lg" ? "w-[150px] h-[150px]" : "w-[120px] h-[120px]";
  const borderClass = size === "lg" ? "border-4" : "border-[3px]";
  const placeholderTextSize = size === "lg" ? "text-5xl" : "text-[2.5rem]";
  const marginBottom = size === "lg" ? "mb-4" : "mb-[15px]";

  return (
    <div className="text-center">
      {photoUrl ? (
        <img
          src={photoUrl}
          alt={alt}
          className={`${dimension} rounded-full object-cover ${borderClass} border-primary ${marginBottom} mx-auto`}
        />
      ) : (
        <div
          className={`${dimension} rounded-full bg-muted flex items-center justify-center ${placeholderTextSize} text-muted-foreground mx-auto ${marginBottom} ${borderClass} border-border`}
        >
          {placeholder}
        </div>
      )}
      <div>
        <label
          className={`inline-block px-4 py-2 bg-primary text-primary-foreground rounded-md text-[0.9rem] font-medium ${
            uploading ? "cursor-not-allowed opacity-60" : "cursor-pointer"
          }`}
        >
          {uploading ? "Uploading..." : uploadLabel}
          <input
            type="file"
            accept="image/*"
            onChange={onUpload}
            disabled={uploading}
            className="hidden"
          />
        </label>
      </div>
    </div>
  );
};

export default PhotoUpload;
